import React from 'react'
import ReactDOM from 'react-dom'
import ApolloClient from "apollo-boost";
import { ApolloProvider } from 'react-apollo';
import { defaults, resolvers } from '../store/resolvers/index.js';
import App from './../components/App.jsx';

import 'froala-editor/css/froala_style.min.css';
import './../../semantic/dist/semantic.min.css';
import './scss/global.scss';

const client = new ApolloClient({
  uri: '/graphql',
  request: operation => {
    const token = localStorage.getItem('actionlab-auth-token');
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : ''
      }
    })
  },
  clientState: {
    resolvers,
    defaults
  },
  onError: ({ networkError }) => {
    console.log('apollo error', networkError);
    if (networkError && networkError.statusCode === 401) {
      // Remove auth token from local storage.
      localStorage.removeItem('actionlab-auth-token');
      window.location.href = '/login';
    }
  }
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/client/index.jsx